import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const getLeftAlignment = (muiTheme: any) => ({
  root: {
    [muiTheme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },

    '& $image': {
      [muiTheme.breakpoints.up('md')]: {
        marginRight: '48px',
      },
    },

    '& $content': {
      [muiTheme.breakpoints.up('md')]: {
        marginLeft: '48px',
      },
    },
  },
});

const getRightAlignment = (muiTheme: any) => ({
  root: {
    [muiTheme.breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
    },

    '& $image': {
      [muiTheme.breakpoints.up('md')]: {
        marginLeft: '48px',
      },
    },

    '& $content': {
      [muiTheme.breakpoints.up('md')]: {
        marginRight: '48px',
      },
    },
  },
});

const getHorizontalOrientation = (muiTheme: any) => ({
  root: {
    alignContent: 'center',
    alignItems: 'center',

    '& $image': {
      [muiTheme.breakpoints.up('md')]: {
        flexBasis: '60%',
      },
    },

    '& $content': {
      [muiTheme.breakpoints.up('md')]: {
        flexBasis: '40%',
      },
    },
  },
});

const getVerticalOrientation = (muiTheme: any) => ({
  root: {
    alignContent: 'flex-start',
    alignItems: 'flex-start',

    '& $image': {
      [muiTheme.breakpoints.up('md')]: {
        flexBasis: '50%',
      },
    },

    '& $content': {
      [muiTheme.breakpoints.up('md')]: {
        flexBasis: '50%',
        marginTop: '136px',
      },
    },
  },
});

const darkTheme = {
  root: {
    '& $person': {
      color: hexToRGBA(TextColors.light, TextOpacities.light1),

      '& strong': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $person': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark1),

      '& strong': {
        color: TextColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      '&.vertical-orientation': getVerticalOrientation(muiTheme).root,
      '&.horizontal-orientation': getHorizontalOrientation(muiTheme).root,
      '&.right-alignment': getRightAlignment(muiTheme).root,
      '&.left-alignment': getLeftAlignment(muiTheme).root,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },

    image: {
      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(4),
        width: '100%',
      },

      [muiTheme.breakpoints.up('md')]: {
        flexGrow: 1,
        flexShrink: 1,
        marginBottom: 0,
      },
    },

    content: {
      flexGrow: 1,
      flexShrink: 1,
    },

    quote: {
      ...muiTheme.typography.h4,

      '&, & *': {
        margin: 0,
      },

      '& + *': {
        marginTop: muiTheme.spacing(3),

        [muiTheme.breakpoints.up('md')]: {
          marginTop: muiTheme.spacing(5),
        },
      },
    },

    person: {
      ...muiTheme.typography.caption,

      '& *': {
        margin: 0,

        '&:not(:first-child)': {
          marginTop: muiTheme.spacing(1),
        },
      },

      '& strong': {
        ...muiTheme.typography.body1,
        fontWeight: 500,
      },
    },
  }),
  { name: 'GenQuote' },
);

export default useStyles;
